import React from "react";
import "./Button.css";
import MaterialIcon from "../MaterialIcon/MaterialIcon";

const Button = ({ children, onClick, className, icon }) => {
  return (
    <button
      className={`Button${className ? " " + className : ""}${
        icon ? " withIcon" : ""
      }`}
      onClick={onClick}
    >
      {icon && <MaterialIcon small name={icon} className="icon" />}
      <span>{children}</span>
    </button>
  );
};
export default Button;
